import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'PATCH', pattern: '/api/units' }

interface InputUnit {
    id?: number
    name: string
    type: number
    parents: number[]
    data: Record<string, any>
    foreignIds: Record<string, any>
}

interface OutputUnit {
    id: number
    name: string
    type: number
    data: Record<string, any>
    foreignIds: Record<string, any>
}

type Params = never
type Body = {
    units: InputUnit[]
}
type Query = never
type Output = {
    units: OutputUnit[]
}

export type UpdateEndpoint = Endpoint<Params, Body, Query, Output>

export const updateRequest = (request: Request, args: RequestArgs<UpdateEndpoint>) =>
    request<UpdateEndpoint>(route, args)
